import { Injectable } from '@angular/core';
import { NavSlimLinks } from '@com-delta-idp/mnx-sitewide-header-ui';
import {
  BookWidgetAem,
  Dates,
  MultiCitySearchCache,
  RetrieveSearch
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { MODIFY_BUTTON } from '../../constants/navigation-links/navigation-linkts-constants';
import { getDateFormat } from '../../utils/header-slim/sanitization.utils';

@Injectable()
export abstract class HeaderSlimAdapterBaseService {
  recentSearchData!: MultiCitySearchCache | RetrieveSearch;
  protected tripTypeFlags = {
    isMultiCity: false,
    isRoundTrip: false,
    isOneWay: false
  };

  protected createNavSlimLinks(
    origin: string,
    destination: string,
    passenger: string,
    aem: BookWidgetAem
  ): NavSlimLinks {
    return {
      origin,
      destination,
      dates: this.transformDates(this.recentSearchData),
      passenger: this.transformPassengers(passenger, aem),
      tripType: this.transformTripType(aem),
      modifyButton: MODIFY_BUTTON
    } as NavSlimLinks;
  }

  protected transformPassengers(passenger: string, aem: BookWidgetAem): string {
    const passengerNumebr = +passenger;
    if (passengerNumebr === 1) {
      return `${passenger} ${aem.passengerField.passenger}`;
    } else if (passengerNumebr > 1) {
      return `${passenger} ${aem.passengerField.passengersLabel}`;
    } else {
      return `${passenger} ${aem.passengerField.passenger}`;
    }
  }

  protected transformDates(
    data: MultiCitySearchCache | RetrieveSearch
  ): string {
    if (this.tripTypeFlags.isMultiCity) {
      const dates = (data as MultiCitySearchCache).value.dates;
      const firstDate = getDateFormat(dates[0].departureDate);
      const lastDate = getDateFormat(dates[dates.length - 1].departureDate);
      return `${firstDate} - ${this.getReturnDateDisplay(firstDate, lastDate)}`;
    }
    const dates = (data as RetrieveSearch).dates;

    const result = this.tripTypeFlags.isRoundTrip
      ? `${dates.departureDate} - ${this.getReturnDateDisplay(
          dates.departureDate,
          dates.returnDate
        )}`
      : dates.departureDate;

    return this.isValidDateString(result) ? result : '';
  }

  private isValidDateString(dateStr: string): boolean {
    return !!(
      dateStr &&
      !dateStr.includes('Invalid Date') &&
      !dateStr.includes('undefined') &&
      !dateStr.includes('null')
    );
  }

  protected transformTripType(aem: BookWidgetAem): string {
    if (this.tripTypeFlags.isMultiCity) {
      return aem.tripTypesField['multiCity'];
    } else if (this.tripTypeFlags.isRoundTrip) {
      return aem.tripTypesField['roundTrip'];
    } else if (this.tripTypeFlags.isOneWay) {
      return aem.tripTypesField['onwWay'];
    }
    return '';
  }

  private getReturnDateDisplay(
    departureDate: string,
    returnDate: string
  ): string {
    const [depMonth] = departureDate.split(' ');
    const [retMonth, retDay] = returnDate.split(' ');
    return depMonth === retMonth ? retDay : returnDate;
  }

  formatDates(dates: Dates): string {
    const formattedDepartureDate = getDateFormat(dates.departureDate);
    const formattedReturnDate = dates.returnDate
      ? getDateFormat(dates.returnDate)
      : '';

    const result = formattedReturnDate
      ? `${formattedDepartureDate} - ${this.getReturnDateDisplay(
          formattedDepartureDate,
          formattedReturnDate
        )}`
      : formattedDepartureDate;

    return this.isValidDateString(result) ? result : '';
  }
}
